import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import {
  callApi,
  fnGetDataSet,
  fnSave,
  fnGetTableById,
} from "@shared/api/restApi"; // BackEnd API
import {
  getInitFormData,
  getNoSlip,
  getTablebySql,
  getconfigData,
  setConfigToColumns,
} from "@shared/utils/CommonUtils";
import { showPopupModal } from "@widgets/CommonModal";
import { showDialog } from "@widgets/CommonDialog";
import { global, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SN_PRD_WMO_REG_001_POP_03 from "@menu/PRD/SN_PRD_WMO_REG_001/SN_PRD_WMO_REG_001_POP_03";
import SN_PRD_WMO_REG_001_POP_02 from "@menu/PRD/SN_PRD_WMO_REG_001/SN_PRD_WMO_REG_001_POP_02";
import SN_PRD_WMO_REG_001_POP_01 from "@menu/PRD/SN_PRD_WMO_REG_001/SN_PRD_WMO_REG_001_POP_01";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { RowNode } from "ag-grid-community";
import { openAddInfoPopup } from "@widgets/commonpopup/sys/openAddInfoPopup";
import { openAddInfoRegPopup } from "@widgets/commonpopup/sys/openAddInfoRegPopup";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import {
  buildJsAddinfoFromFlags,
  extractAddInfoFlags,
  hydrateRowsWithAddInfo,
} from "@shared/utils/AddInfoUtils";
import {
  CellValueChangedEvent,
  SnGridRef,
} from "@shared/components/GridV2/SnGridTypes";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_PRD_WMO_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable

  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global();
  const { menuItems } = useMenuStore();
  //#endregion

  //#region  Components useState
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [headerInfo, setHeaderInfo] = useState<any>({
    grid1: {},
    grid2: {},
    grid3: {},
  });
  const selectedTabPage = useRef<string>("1");
  const [addInfoFlags, setAddInfoFlags] = useState<string[]>([]);
  const [addInfoFlags2, setAddInfoFlags2] = useState<string[]>([]);
  const [_qtdy04_visible, set_qtdy04_visible] = useState(true);
  const _dt = useRef<any>();
  const noLineP = useRef<number>(0);
  const _chk_newRow = useRef<string>("");
  const isYnEnd = useRef<boolean>(true);
  const _nm_rout_old = useRef<string>("");
  const _cd_item_old = useRef<string>("");
  const [gridFocus, setGridFocus] = useState(false);
  const prd1001 = useRef<string>("");
  const prd1002 = useRef<string>("");
  const prd1003 = useRef<string>("");
  const prd1004 = useRef<string>("");
  const tmp_cd_wh = useRef<string>("");
  useRef<string>("");

  const woInfoRef = useRef({ cd_wo: "", st_wo: "" });
  //#endregion
  const cd_menu = Menuprops.cd_menu || "SN_PRD_WMO_REG_001";
  const defaultSize = { panel1height: "49.5%", panel2height: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  const loadAddInfoFlags = async (
    idTarget = "grid1",
    setFlags = setAddInfoFlags
  ) => {
    const result: any = await fnGetDataSet({
      id: "sys_addinfo_pop_01_01",
      params: {
        cd_firm: userInfo?.cd_firm ?? "",
        cd_menu: Menuprops?.cd_menu ?? "",
        id_target: idTarget,
      },
    });
    const rows = result?.[0] || [];
    const flags = extractAddInfoFlags(rows);
    setFlags(flags);
    return flags;
  };
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
        await loadAddInfoFlags("grid1", setAddInfoFlags);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rtn: any = await getInitFormData();
        const sqlQuery2 = {
          sql: "select coalesce(nm_flag,'') as nm_flag from mas_codel where cd_firm = :cd_firm and cd_clas = 'MAS063' and cd_flag = '04';",
          cd_firm: userInfo.cd_firm,
        };
        const params2 = await getTablebySql(sqlQuery2);
        if (params2.length > 0) {
          const hasName = params2[0].nm_flag !== "";
          rtn.grid.grid1.push({
            cd_column: "qt_dummy04_mi",
            nm_column: hasName ? params2[0].nm_flag : "qt_dummy04_mi",
            qt_width: 120,
            tp_column: "SnNumberBox",
            fg_visible: hasName ? "Y" : "N",
            yn_required: "N",
            yn_sum: "Y",
            dc_editcon: hasName ? "true" : "",
            editable: false,
          });
          if (!hasName) {
            set_qtdy04_visible(false);
          }
        }

        const sqlQuery = {
          sql: "select cd_wo, case when coalesce(yn_autorel,'N') = 'Y' then 'R' else 'F' end as st_wo from mas_wotype where cd_firm = :cd_firm and yn_default = 'Y' limit 1",
          cd_firm: userInfo.cd_firm,
        };
        const result = await getTablebySql(sqlQuery);
        if (result.length > 0) {
          woInfoRef.current = {
            cd_wo: result[0].cd_wo,
            st_wo: result[0].st_wo,
          };
        }

        const dcCtrl1 = await getconfigData("PRD1001");
        const dcCtrl2 = await getconfigData("PRD1002");
        const dcCtrl3 = await getconfigData("PRD1003");
        const dcCtrl4 = await getconfigData("PRD1004");

        prd1001.current = dcCtrl1[0].dc_ctrl;
        prd1002.current = dcCtrl2[0].dc_ctrl;
        prd1003.current = dcCtrl3[0].dc_ctrl;
        prd1004.current = dcCtrl4[0].dc_ctrl;
      } catch (error) {}
    };
    fetchData();
  }, [userInfo]);

  useEffect(() => {
    gridRefs.current["grid1"].current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  const drilldownHandledRef = useRef<any>(null);
  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid3.length > 0
    ) {
      // 조회·팝업 등으로 컬럼이 다시 만들어질 때마다 드릴다운이 재실행되지 않게(처리탭으로 되돌아가는 문제) 드릴다운 1건당 1번만.
      if (drilldownHandledRef.current !== Menuprops) {
        drilldownHandledRef.current = Menuprops;
        onActivate(Menuprops.nodeData);
      }
    }
  }, [columns, Menuprops]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
  }));
  //#region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    const modifiedRowsL2 = gridRefs.current["grid3"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0 ||
      modifiedRowsL2.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const checkSave: any = onSave();
        if (!checkSave) {
          return;
        }
      }
    }
    try {
      const params = {
        id: "sn_prd_wmo_reg_001_01",
        params: searchRef.current.getFormdata(),
      };

      const data: any = await fnGetDataSet(params);

      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        setGridFocus(true);
      }

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  const onPrint = async () => {
    gridRefs.current["grid1"].current?.stopEditing();
    gridRefs.current["grid2"].current?.stopEditing();
    gridRefs.current["grid3"].current?.stopEditing();

    const searchInfo = searchRef.current.getFormdata();
    const selectedRow = gridRefs.current["grid1"].current?.getSelectedRows();
    if (selectedRow.length < 1) {
      await showDialog("alter", "선택된 작업지시정보가 없습니다.");
      return;
    }
    return {
      cd_firm: userInfo.cd_firm,
      cd_biz: searchInfo.cd_biz,
      no_wo: selectedRow[0].no_wo,
    };
  };
  //#region OnInsert
  const onInsert = async () => {
    try {
      const searchForm = searchRef.current.getFormdata();

      if (searchForm.tp_wo === "") {
        showDialog("alter", "공정경로유형을 선택하시기 바랍니다.");
        return;
      }
      const newRow = {};
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  //#region OnDelete
  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() === 0) return;
    const footerData2 = gridRefs.current["grid2"].current?.getFooterData();
    const footerData3 = gridRefs.current["grid3"].current?.getFooterData();
    const qtWork = footerData2?.qt_work;
    const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();
    const noWoreq = focusedRow.data?.no_woreq ?? "";
    const noLineWoreq = focusedRow.data?.no_line_woreq;
    const qt_wo = focusedRow.data?.qt_wo;
    if (focusedRow.data?.no_mrp) {
      showDialog(
        "error",
        "MRP 또는 MPS 확정으로 자동 생성된 건은 삭제할 수 없습니다."
      );
      return;
    }
    if (focusedRow.data?.st_wo === "S") {
      showDialog("error", "진행 중인 작업지시는 삭제 할 수 없습니다.");
      return;
    }
    if (focusedRow.data?.st_wo === "C") {
      showDialog("error", "마감 된 작업지시는 삭제 할 수 없습니다.");
      return;
    }
    // 한글 주석: 자동발행(yn_autorel=Y) 지시는 발행(R) 상태여도 확정과 동일하게 삭제를 허용한다.
    // (기존 코드는 st_wo가 아니라 no_mrp를 비교해 발행 차단이 동작하지 않던 오타도 함께 수정)
    if (focusedRow.data?.st_wo === "R" && focusedRow.data?.yn_autorel !== "Y") {
      showDialog(
        "error",
        "발행된 작업지시 정보입니다.\n발행 취소 후 삭제 해주시기 바랍니다."
      );
      return;
    }
    if (focusedRow.data?.qt_work !== 0) {
      showDialog("error", "진행된 수량이 존재합니다.");
      return;
    }
    if (qtWork !== 0) {
      showDialog("error", "공정 진행된 수량이 존재합니다.");
      return;
    }
    if (footerData3.qt_isu !== 0) {
      showDialog(
        "error",
        "출고된 자재가 존재합니다.\n출고전표 삭제 후 진행해주시기 바랍니다."
      );
      return;
    }
    if (footerData3.qt_req !== 0) {
      showDialog(
        "error",
        "출고요청된 자재가 존재합니다.\n출고요청전표 삭제 후 진행해주시기 바랍니다."
      );
      return;
    }
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridRefs.current["grid3"].current?.deleteAllRows();
    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();
    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      return;
    }

    const isSaved = await onSave();
    if (isSaved) {
      if (noWoreq === "") return;
      const params = {
        cd_firm: userInfo.cd_firm,
        no_woreq: noWoreq,
        no_line_woreq: noLineWoreq,
        qt_wo: qt_wo,
      };
      await callApi("SN_PRD_WMO_REG_01_btnOndelete", params);
    }
  };
  //#region OnDeleteRow
  const onDeleteRow = async () => {
    if (
      gridRefs.current["grid2"].current?.getDisplayedRowCount() < 0 ||
      gridRefs.current["grid3"].current?.getDisplayedRowCount() < 0
    ) {
      return;
    }
    const focusedRow = gridRefs.current["grid1"].current?.focusedRowNode();

    const st_wo = focusedRow.data.st_wo;
    const footerData2 = gridRefs.current["grid2"].current?.getFooterData();
    const qt_work = footerData2?.qt_work;
    if (focusedRow.data?.no_wo !== "") {
      // const sqlQuery1 = {
      //   sql: "select st_wo from prd_wo where cd_firm = #{cd_firm} and no_wo = #{no_wo}",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: selectedRows[0].data?.no_wo,
      // };
      // const params1 = await getTablebySql(sqlQuery1);
      // if (params1?.length > 0) {
      //   st_wo = params1[0]["st_wo"];
      // }

      // const sqlQuery2 = {
      //   sql: "select coalesce(sum(qt_work),0) as qt_work from prd_woproc where cd_firm = #{cd_firm} and no_wo = #{no_wo}",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: selectedRows[0].data?.no_wo,
      // };
      // const params2 = await getTablebySql(sqlQuery2);
      // if (params2?.length > 0) {
      //   qt_work = params2[0]["qt_work"];
      // }

      if (st_wo === "C") {
        showDialog("error", "지시상태 마감의 경우 행추가 하실 수 없습니다.");
        return;
      } else if (st_wo === "R") {
        // 한글 주석: 자동발행 지시는 발행 상태여도 확정과 동일하게 행추가/행삭제를 허용한다.
        if (focusedRow.data?.yn_autorel !== "Y") {
          showDialog(
            "error",
            "발행된 작업지시므로 행추가/행삭제 할 수 없습니다."
          );
          return;
        }
      }
    }

    if (selectedTabPage.current === "1") {
      gridRefs.current["grid2"].current?.deleteSelectedRows();
    } else {
      gridRefs.current["grid3"].current?.deleteSelectedRows();
    }
  };
  //#region onAddRow
  const onAddRow = async () => {
    gridRefs.current["grid1"].current?.stopEditing();
    const selectedRows = gridRefs.current["grid1"].current?.getSelectedRows();
    const st_wo = selectedRows[0].st_wo;
    const footerData2 = gridRefs.current["grid2"].current?.getFooterData();
    const qt_work = footerData2?.qt_work;
    try {
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      if (selectedRows[0].no_wo !== "") {
        // const sqlQuery1 = {
        //   sql: "select st_wo from prd_wo where cd_firm = #{cd_firm} and no_wo = #{no_wo}",
        //   cd_firm: userInfo.cd_firm,
        //   no_wo: selectedRows[0].data?.no_wo,
        // };
        // const params1 = await getTablebySql(sqlQuery1);
        // if (params1?.length > 0) {
        //   st_wo = params1[0]["st_wo"];
        // }

        // const sqlQuery2 = {
        //   sql: "select coalesce(sum(qt_work),0) as qt_work from prd_woproc where cd_firm = #{cd_firm} and no_wo = #{no_wo}",
        //   cd_firm: userInfo.cd_firm,
        //   no_wo: selectedRows[0].data?.no_wo,
        // };
        // const params2 = await getTablebySql(sqlQuery2);
        // if (params2?.length > 0 && params2[0]["qt_work"] !== null) {
        //   qt_work = params2[0]["qt_work"];
        // }

        if (st_wo === "C") {
          showDialog("error", "지시상태 마감의 경우 행추가 하실 수 없습니다.");
          return;
        } else if (st_wo === "R") {
          // 한글 주석: 자동발행 지시는 발행 상태여도 확정과 동일하게 행추가/행삭제를 허용한다.
          if (selectedRows[0].yn_autorel !== "Y") {
            showDialog(
              "error",
              "발행된 작업지시므로 행추가/행삭제 할 수 없습니다."
            );
            return;
          }
        }
      }

      if (selectedTabPage.current === "1") {
        //if (selectedRows[0].no_wo === "") {
        //  showDialog("error", "라인정보를 입력 하시기 바랍니다.");
        //  return;
        //}
        noLineP.current =
          gridRefs.current["grid2"].current?.getDisplayedRowCount();
        _chk_newRow.current = "M";
        const newRow = {};
        gridRefs.current["grid2"].current?.addRow(newRow);
      } else {
        noLineP.current =
          gridRefs.current["grid3"].current?.getDisplayedRowCount();

        _chk_newRow.current = "M";
        const rows: any[] = [];
        gridRefs.current["grid2"].current?.forEachFilteredNode((node: any) => {
          rows.push(node.data);
        });
        if (rows.length !== 0) {
          const sqlQuery2 = {
            sql: "select dc_ctrl from sys_config where cd_firm = :cd_firm and cd_ctrl = 'PRD1137'",
            cd_firm: userInfo.cd_firm,
          };
          const params2 = await getTablebySql(sqlQuery2);

          rows.sort((a, b) => Number(a.no_line) - Number(b.no_line));
          const newRow = {
            cd_op:
              params2[0].dc_ctrl === "S"
                ? rows[0].cd_op
                : rows[rows.length - 1].cd_op,
            nm_op:
              params2[0].dc_ctrl === "S"
                ? rows[0].nm_op
                : rows[rows.length - 1].nm_op,
          };
          gridRefs.current["grid3"].current?.addRow(newRow);
        } else {
          gridRefs.current["grid3"].current?.addRow({});
        }
      }
    } catch (error: any) {}
  };
  //#region InitnewRowH
  const onBeforeAddRowH = () => {
    try {
      const salSohChanges =
        gridRefs.current["grid1"].current?.getChange().insert;
      const searchParam = searchRef.current.getFormdata();
      if (salSohChanges.length > 0) return false;

      return {
        cd_firm: userInfo.cd_firm,
        cd_user_reg: userInfo.cd_user,
        no_wo: "",
        cd_biz: userInfo.cd_biz,
        nm_biz: userInfo.nm_biz,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_wo: todayform,
        tp_wo: searchParam.tp_wo,
        dt_start: todayform,
        dt_end: todayform,
        fg_wo: "ETC",
        tp_rout: searchParam.tp_wo,
        qt_work: 0,
        qt_wo: 1,
        qt_rcv: 0,
        no_line_wwo: 0,
        no_line_woreq: 0,
        qt_req: 0,
        yn_autorel: "N",
        yn_autorcv: "N",
        no_line_so: 0,
        cd_wo: woInfoRef.current.cd_wo,
        st_wo: woInfoRef.current.st_wo,
      };
    } catch (error: any) {
      return false;
    }
  };
  //#region InitnewrowL
  const onBeforeAddRowL = () => {
    try {
      // 한글 주석: focusedRowNode()는 RowNode(배열 아님)라 기존 .length === 0 비교는 항상 통과했었다.
      const focusedNode = gridRefs.current["grid1"].current?.focusedRowNode();
      if (!focusedNode) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }
      // 한글 주석: 자재 전개도 포커스 행 기준(reload와 동일). 선택이 다른 행에 남아 있어도
      // no_wo/qt_wo/cd_rout 등이 엉뚱한 행에서 복사되지 않게 한다.
      const baseRow =
        focusedNode.data ??
        gridRefs.current["grid1"].current?.getSelectedRows()?.[0];

      let maxNoLine = gridRefs.current["grid3"].current.getMaxValue("no_line");
      let updatedRow: any;
      switch (_chk_newRow.current) {
        case "P":
          const qtNeed =
            Number(_dt.current[0][noLineP.current].qt_unit) *
            Number(baseRow.qt_wo);
          updatedRow = {
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_line: maxNoLine + 1,
            no_wo: baseRow.no_wo,
            cd_rout: baseRow.cd_rout,
            cd_matl: _dt.current[0][noLineP.current].cd_matl,
            nm_matl: _dt.current[0][noLineP.current].nm_matl,
            dc_item_spec_matl: _dt.current[0][noLineP.current].dc_item_spec,
            dc_item_unit_matl: _dt.current[0][noLineP.current].dc_item_unit,
            tp_bom: _dt.current[0][noLineP.current].tp_bom,
            qt_need: qtNeed,
            qt_unit: Number(_dt.current[0][noLineP.current].qt_need),
            dt_dlv: baseRow.dt_wo,
            cd_op: _dt.current[0][noLineP.current].cd_op,
            nm_op: _dt.current[0][noLineP.current].nm_op,
            cd_wh: _dt.current[0][noLineP.current].cd_wh_isu ?? baseRow.cd_wh,
            yn_bf: _dt.current[0][noLineP.current].yn_bf,
            yn_matl_check: _dt.current[0][noLineP.current].yn_matl_check,
          };
          noLineP.current++;
          _chk_newRow.current = "M";
          return updatedRow;
        case "B":
          updatedRow = {
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_line: maxNoLine + 1,
            no_wo: baseRow.no_wo,
            cd_matl: _dt.current[0][noLineP.current].cd_matl,
            nm_matl: _dt.current[0][noLineP.current].nm_matl,
            dc_item_spec_matl: _dt.current[0][noLineP.current].dc_item_spec,
            dc_item_unit_matl: _dt.current[0][noLineP.current].dc_item_unit,
            qt_unit: Number(_dt.current[0][noLineP.current].qt_need),
            qt_need:
              Number(_dt.current[0][noLineP.current].qt_need) * baseRow.qt_wo,
            dt_dlv: baseRow.dt_wo,
            cd_op: _dt.current[0][noLineP.current].cd_op,
            nm_op: _dt.current[0][noLineP.current].nm_op,
            yn_bf: _dt.current[0][noLineP.current].yn_bf,
            yn_matl_check: _dt.current[0][noLineP.current].yn_matl_check,
            cd_rout: baseRow.cd_rout,
            cd_wh: (tmp_cd_wh.current as any)[0]?.cd_wh_isu ?? baseRow.cd_wh,
            nm_wh: (tmp_cd_wh.current as any)[0]?.nm_wh ?? baseRow.nm_wh,
          };
          noLineP.current++;
          _chk_newRow.current = "M";
          return updatedRow;
        case "M":
          updatedRow = {
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_line: maxNoLine + 1,
            no_wo: baseRow.no_wo,
            dt_dlv: "",
            qt_unit: 0,
            qt_need: 0,
            cd_rout: baseRow.cd_rout,
          };
          if (noLineP.current === 0) {
            updatedRow.dt_dlv = baseRow.dt_wo;
          } else {
            updatedRow.dt_dlv = baseRow.dt_dlv;
          }
          return updatedRow;
      }
    } catch (error: any) {
      return false;
    }
  };
  //#region InitnewrowL2 현재 그리드2,공정정보
  const onBeforeAddRowL2 = () => {
    try {
      // 한글 주석: focusedRowNode()는 RowNode(배열 아님)라 기존 .length === 0 비교는 항상 통과했었다.
      const focusedNode = gridRefs.current["grid1"].current?.focusedRowNode();
      if (!focusedNode) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }
      // 한글 주석: reload는 포커스 행 기준으로 전개하므로 포커스 행 데이터를 우선 사용한다.
      // 선택(selection)이 다른 행에 남아 있으면 st_wo/no_wo가 엉뚱한 행에서 복사되던 문제 방지.
      const baseRow =
        focusedNode.data ??
        gridRefs.current["grid1"].current?.getSelectedRows()?.[0];
      let maxNoLine = gridRefs.current["grid2"].current.getMaxValue("no_line");
      let updatedRow: any;
      switch (_chk_newRow.current) {
        case "R":
          updatedRow = {
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_wo: baseRow.no_wo,
            no_line: maxNoLine + 1,
            cd_op: _dt.current[0][noLineP.current].cd_op,
            nm_op: _dt.current[0][noLineP.current].nm_op,
            qt_wo: baseRow.qt_wo,
            yn_end: _dt.current[0][noLineP.current].yn_end,
            yn_work: _dt.current[0][noLineP.current].yn_work,
            yn_qc: _dt.current[0][noLineP.current].yn_qc,
            st_proc: baseRow.st_wo,
            qt_work: 0,
            qt_qc: 0,
            yn_sct: "N",
          };
          noLineP.current++;
          _chk_newRow.current = "M";
          return updatedRow;
        case "M":
          updatedRow = {
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_wo: baseRow.no_wo,
            no_line: maxNoLine + 1,
            qt_wo: baseRow.qt_wo,
            st_proc: baseRow.st_wo,
            yn_end: "N",
            yn_work: "N",
            yn_qc: "N",
            qt_work: 0,
            qt_qc: 0,
            yn_sct: "N",
          };
          return updatedRow;
      }
    } catch (error: any) {
      return false;
    }
  };

  //#region OnSave
  const onSave = async () => {
    let prdWoChanges;
    let prdWobillChanges;
    let prdWoprocChanges;
    let yn_chkso,
      yn_chkdoc,
      yn_chkop,
      ynPhn,
      tpRout,
      yn_chkworeq,
      dt: any,
      dt_boml: any,
      dt_phn: any,
      noWoreq,
      qt_wo,
      noLineWoreq;

    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      gridRefs.current["grid3"].current?.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      const requiredValuesCheckL =
        gridRefs.current["grid3"].current?.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      prdWoChanges = gridRefs.current["grid1"].current?.getChange();
      const headerInserts = prdWoChanges.insert ?? [];

      const headerUpdate = prdWoChanges.update ?? [];
      if (headerInserts.length > 0) {
        noWoreq = headerInserts[0]?.no_woreq ?? "";
        qt_wo = headerInserts[0]?.qt_wo ?? "";
        noLineWoreq = headerInserts[0]?.no_line_woreq;
      }

      if (prd1001.current === "") {
        yn_chkso = "N";
      } else {
        yn_chkso = prd1001.current;
      }

      if (prd1002.current === "") {
        yn_chkdoc = "N";
      } else {
        yn_chkdoc = prd1002.current;
      }

      if (prd1003.current === "") {
        yn_chkworeq = "N";
      } else {
        yn_chkworeq = prd1003.current;
      }

      if (prd1004.current === "") {
        yn_chkop = "N";
      } else {
        yn_chkop = prd1004.current;
      }

      // const sqlQuery = {
      //   sql: "select coalesce(dc_ctrl, 'N') as yn_so from sys_config where cd_firm = #{cd_firm} and cd_ctrl = 'PRD1001'",
      //   cd_firm: userInfo.cd_firm,
      // };
      //dt = await getTablebySql(sqlQuery);

      // if (dt != null && dt.length > 0) {
      //   if (dt[0].yn_so === "") {
      //     yn_chkso = "N";
      //   } else {
      //     yn_chkso = dt[0].yn_so;
      //   }
      // }

      // const sqlQuery1 = {
      //   sql: "select coalesce(dc_ctrl, 'N') as yn_so from sys_config where cd_firm = #{cd_firm} and cd_ctrl = 'PRD1002'",
      //   cd_firm: userInfo.cd_firm,
      // };

      // dt = await getTablebySql(sqlQuery1);
      // if (dt != null && dt.length > 0) {
      //   if (dt[0].yn_so) {
      //     yn_chkdoc = "N";
      //   } else {
      //     yn_chkdoc = dt[0].yn_so;
      //   }
      // }

      // const sqlQuery2 = {
      //   sql: "select coalesce(dc_ctrl, 'N') as yn_so from sys_config where cd_firm = #{cd_firm} and cd_ctrl = 'PRD1003'",
      //   cd_firm: userInfo.cd_firm,
      // };

      // dt = await getTablebySql(sqlQuery2);
      // if (dt != null && dt.length > 0) {
      //   if (dt[0].yn_so) {
      //     yn_chkworeq = "N";
      //   } else {
      //     yn_chkworeq = dt[0].yn_so;
      //   }
      // }

      // const sqlQuery3 = {
      //   sql: "select coalesce(dc_ctrl, 'N') as yn_so from sys_config where cd_firm = #{cd_firm} and cd_ctrl = 'PRD1004'",
      //   cd_firm: userInfo.cd_firm,
      // };

      // dt = await getTablebySql(sqlQuery3);
      // if (dt != null && dt.length > 0) {
      //   if (dt[0].yn_so === "") {
      //     yn_chkop = "N";
      //   } else {
      //     yn_chkop = dt[0].yn_so;
      //   }
      // }

      //Only Added/Inserted Rows
      for (const row of [...headerInserts, ...headerUpdate]) {
        const qt_wo = row?.qt_wo;
        const no_so = row?.no_so;
        const no_woreq = row?.no_woreq;
        const qt_app = row?.qt_app;
        if ("S" === row.tp_wo) {
          const payload = {
            id: "rout_item",
            params: {
              cd_firm: userInfo.cd_firm,
              cd_item: row.cd_item,
            },
          };

          const data = await fnGetTableById(payload);
          if (Array.isArray(data) && data.length === 0) {
            await showDialog(
              "alter",
              "공정경로가 표준인 제품은 공정품목 등록이 필요합니다."
            );
            return;
          }
        }

        // Insert rows: check for qt_wo == 0
        if (headerInserts.includes(row) && qt_wo === 0) {
          showDialog("error", "지시량이 누락되었습니다.");
          return;
        }

        if (yn_chkso === "Y" && no_so?.trim() === "") {
          showDialog("error", "수주번호정보가 누락되었습니다.");
          return;
        }

        if (yn_chkworeq === "Y" && no_woreq?.trim() !== "" && qt_wo > qt_app) {
          showDialog("error", "지시량이 의뢰수량을 초과했습니다.");
          return;
        }
      }

      for (const row of headerInserts) {
        gridRefs.current["grid2"].current?.applyFilters({ no_wo: row.no_wo });
        gridRefs.current["grid3"].current?.applyFilters({ no_wo: row.no_wo });

        if (gridRefs.current["grid3"].current?.getDisplayedRowCount() === 0) {
          selectedTabPage.current = "2";
          await onBtnsClick("btnReload");
        }

        if (gridRefs.current["grid3"].current?.getDisplayedRowCount() <= 0) {
          showDialog("alter", "해당 제품의 BOM정보가 없습니다.");
          return;
        }

        if (yn_chkop === "Y") {
          let hasMissingOp = false;

          gridRefs.current["grid3"].current?.forEachNodeAfterFilterAndSort(
            (node: any) => {
              if (!node.data?.cd_op?.trim()) {
                hasMissingOp = true;
              }
            }
          );

          if (hasMissingOp) {
            showDialog(
              "alter",
              "투입자재중 투입공정이 누락된 자재가 있습니다."
            );
            return;
          }
        }

        if (gridRefs.current["grid2"].current?.getDisplayedRowCount() === 0) {
          selectedTabPage.current = "1";
          await onBtnsClick("btnReload");
        }
      }

      /*let no_wo,
      st_wo,
        no_line = -1;
      for (const node of gridApiRef2.current.api.getRenderedNodes()) {
        if (node.data?.no_wo === "") {
          no_wo = node.data?.no_wo;
          for (const row1 of getRenderedNodes) {
            if (row1.data?.no_wo === no_wo) {
              no_line = row1.rowIndex;
            }
          }
          if (no_line < 0) continue;
          const rowNode =
            gridApiRef1.current.api.getDisplayedRowAtIndex(no_line);
          if (rowNode?.data?.["yn_autorel"] === "Y") {
            gridApiRef1.current.setValue(rowNode, "st_wo", "R");
            st_wo = "R";

            for (const row3 of getRenderedNodes3) {
              gridApiRef3.current.setValue(row3, "st_proc", st_wo);
            }
          } else {
            st_wo = rowNode.data?.st_wo;

            for (const row3 of getRenderedNodes3) {
              gridApiRef3.current.setValue(row3, "st_proc", st_wo);
            }
          }
        }
      }
      버전 업그레이드 진행하면서 어떻게 변환해야하는지 모르겠음.  
      */

      prdWoprocChanges = gridRefs.current["grid2"].current?.getChange();
      const allProcessRows: any[] = [];
      gridRefs.current["grid2"].current?.forEachNode((node: RowNode) => {
        if (node.data) allProcessRows.push(node.data);
      });
      const targetRows = [
        ...(prdWoprocChanges.insert ?? []),
        ...(prdWoprocChanges.update ?? []),
      ];
      targetRows.forEach((targetRow: any) => {
        const previousRow = allProcessRows
          .filter(
            (row: any) =>
              row.cd_firm === targetRow.cd_firm &&
              (row.no_wo ?? "") === (targetRow.no_wo ?? "") &&
              Number(row.no_line) < Number(targetRow.no_line)
          )
          .sort((a: any, b: any) => Number(b.no_line) - Number(a.no_line))[0];

        targetRow.cd_op_pre = previousRow?.cd_op ?? null;
      });
      prdWobillChanges = gridRefs.current["grid3"].current?.getChange();

      if (
        prdWoChanges.modifiedRowcount < 1 &&
        prdWobillChanges.modifiedRowcount < 1 &&
        prdWoprocChanges.modifiedRowcount < 1
      ) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const lineInserts = prdWobillChanges.insert ?? [];
      const sublineInserts = prdWoprocChanges.insert ?? [];

      for (let row of headerInserts) {
        if (!row.no_col) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            const no_slip = await getNoSlip(
              cd_module,
              1,
              "WMO",
              row.dt_wo,
              cd_menu
            );
            if (no_slip) {
              row.no_wo = no_slip;

              const focusedCell =
                gridRefs.current["grid1"].current.focusedRowNode();
              if (focusedCell) {
                focusedCell.setDataValue("no_wo", no_slip);
              }

              for (let row of lineInserts) {
                if (!row.no_wo) {
                  if (no_slip) {
                    row.no_wo = no_slip;
                  }
                }
              }

              for (let row of sublineInserts) {
                if (!row.no_wo) {
                  if (no_slip) {
                    row.no_wo = no_slip;
                  }
                }
              }
              gridRefs.current["grid2"].current.applyFilters({
                no_wo: no_slip,
              });
              gridRefs.current["grid3"].current.applyFilters({
                no_wo: no_slip,
              });
            }
          } catch (error: any) {}
        }
      }
      // 한글 주석: 저장 시점에 flags 상태가 비어있으면 재조회하여 누락 저장을 방지한다.
      const flagsForSave =
        addInfoFlags.length > 0
          ? addInfoFlags
          : await loadAddInfoFlags("grid1", setAddInfoFlags);

      // 한글 주석: 저장 직전에 헤더 변경행의 동적 부가항목 컬럼값을 js_addinfo로 묶는다.
      const woWithAddInfo = {
        ...prdWoChanges,
        insert: (prdWoChanges.insert ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flagsForSave),
        })),
        update: (prdWoChanges.update ?? []).map((row: any) => ({
          ...row,
          js_addinfo: buildJsAddinfoFromFlags(row, flagsForSave),
        })),
      };
      const SaveData = {
        prd_wo: woWithAddInfo,
        prd_wobill: prdWobillChanges,
        prd_woproc: prdWoprocChanges,
      };

      await fnSave("SN_PRD_WMO_REG_001_SAVE_01", SaveData);

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      if (headerInserts.length > 0) {
        if (noWoreq === "" || noWoreq === null) return;

        const params = {
          cd_firm: userInfo.cd_firm,
          no_woreq: noWoreq,
          no_line_woreq: noLineWoreq,
          qt_wo: qt_wo,
        };
        await callApi("SN_PRD_WMO_REG_01_btnOnInsert", params);
      }

      return true;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  const onBtnsClick = async (id: string) => {
    //#region BtnaddRow
    if (id === "addRow") {
      onAddRow();
    }
    //#region BtndeleteRow
    if (id === "deleteRow") {
      onDeleteRow();
    }
    //#region BtnappReq
    if (id === "btnAppReq") {
      const selectedNode =
        gridRefs.current["grid1"].current.getSelectedRows()[0];
      if (selectedNode.state !== "insert") {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
      };
      const component = (
        <SN_PRD_WMO_REG_001_POP_02 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "작업지시의뢰적용",
        children: component,
      });
      if (!result || result === "close") return;
      const headerResult = result[0];
      const lineResult = result[1];

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedRowNodeH && headerResult[0]) {
        for (const key in headerResult[0]) {
          focusedRowNodeH.setDataValue(key, headerResult[0][key], "noEvent");
        }
      }
      lineResult.map((result: any) => {
        if (headerResult[0]) {
          for (const key in result) {
            if (key === "cd_item")
              focusedRowNodeH.setDataValue(key, result[key]);
            else focusedRowNodeH.setDataValue(key, result[key], "noEvent");
          }
          focusedRowNodeH.setDataValue("js_addinfo", lineResult[0].js_addinfo);
        }
      });
      focusedRowNodeH.setDataValue("qt_wo", lineResult[0].qt_app, "noEvent");

      focusedRowNodeH.setDataValue(
        "no_line_woreq",
        lineResult[0].no_line,
        "noEvent"
      );

      focusedRowNodeH.setDataValue("yn_from_popup", "Y", "noEvent");
      focusedRowNodeH.setDataValue("qt_app", lineResult[0].qt_app, "noEvent");
      focusedRowNodeH.setDataValue("nm_emp", userInfo.nm_emp, "noEvent");
      focusedRowNodeH.setDataValue("cd_emp", userInfo.cd_emp, "noEvent");
    }

    //의뢰적용

    //#region BtnDetail
    if (id === "btnDetail") {
      const focusedNode = gridRefs.current["grid1"].current.focusedRowNode();
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() === 0)
        return;

      if (focusedNode && focusedNode.data?.state === "insert") {
        showDialog("alter", "저장 후 입력 가능합니다.");
        return;
      }
      const selectedData = { no_wo: focusedNode.data?.no_wo };
      const component = (
        <SN_PRD_WMO_REG_001_POP_01 selectedData={selectedData} />
      );

      const result = await showPopupModal({
        title: "작업지시 사양정보",
        children: component,
        validation: false,
        width: "60%",
        height: "60vh",
      });
      if (!result || result === "close") return;
    }
    if (id === "btnHalfItem") {
      const focusedNode = gridRefs.current["grid1"].current.focusedRowNode();
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() === 0)
        return;

      if (focusedNode && focusedNode.data?.state === "insert") {
        showDialog("alter", "저장 후 입력 가능합니다.");
        return;
      }
      const selectedData = {
        no_wo: focusedNode.data?.no_wo,
        qt_wo: focusedNode.data?.qt_wo,
        cd_item: focusedNode.data?.cd_item,
        nm_item: focusedNode.data?.nm_item,
        dc_item_spec: focusedNode.data?.dc_item_spec,
        dc_item_unit: focusedNode.data?.dc_item,
        no_so: focusedNode.data?.no_so,
        no_line_so: focusedNode.data?.no_line_so,
      };
      const component = (
        <SN_PRD_WMO_REG_001_POP_03 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "반제품작업지시 생성",
        children: component,
        validation: true,
      });
      if (!result || result === "close") return;
      else await onSearch();
    }
    //#region BtnReload
    if (id === "btnReload") {
      const selectedNode = gridRefs.current["grid1"].current.focusedRowNode();
      await reload(selectedNode);
    }
    //#region BtnUp
    if (id === "btnUp") {
      if (
        gridRefs.current["grid2"].current.getDisplayedRowCount() === 0 ||
        gridRefs.current["grid2"].current.getDisplayedRowCount() === 1
      ) {
        return;
      }
      const parendNodes = gridRefs.current["grid1"].current.focusedRowNode();
      const focusedRowNode = gridRefs.current["grid2"].current.focusedRowNode();
      if (focusedRowNode.length <= 0) return;

      const noWo = focusedRowNode.data?.no_wo;
      const noLine = focusedRowNode.data?.no_line;

      // const sqlQuery1 = {
      //   sql: "select count(1) as cnt from prd_wo where cd_firm = #{cd_firm} and no_wo = #{no_wo} and (qt_rcv > 0)",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: noWo,
      // };
      // const params1 = await getTablebySql(sqlQuery1);
      // let cnt1 = params1?.length > 0 ? params1[0]["cnt"] : 0;

      if ((parendNodes.data?.qt_rcv ?? 0) > 0) {
        showDialog("alter", "이미 진행된 건 입니다.");
        return;
      }
      //////////
      // const sqlQuery2 = {
      //   sql: "select count(1) as cnt from prd_woproc where cd_firm = #{cd_firm} and no_wo = #{no_wo} and no_line = #{no_line} and qt_work <> 0",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: noWo,
      //   no_line: noLine,
      // };
      // const params2 = await getTablebySql(sqlQuery2);
      // let cnt2 = params2?.length > 0 ? params2[0]["cnt"] : 0;

      //focus node's qt_work
      if ((focusedRowNode.data?.qt_work ?? 0) !== 0) {
        showDialog("alter", "이미 진행된 건 입니다.");
        return;
      }
      ///////////
      // const sqlQuery3 = {
      //   sql: "select count(1) as cnt from prd_woproc where cd_firm = #{cd_firm} and no_wo = #{no_wo} and no_line = #{no_line} and qt_work <> 0",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: noWo,
      //   no_line: noLine2,
      // };
      // const params3 = await getTablebySql(sqlQuery3);
      // let cnt3 = params3?.length > 0 ? params3[0]["cnt"] : 0;

      //Prev node's qt_work
      if ((focusedRowNode.data?.qt_work ?? 0) !== 0) {
        showDialog("alter", "이전 공정이 진행된 건 입니다.");
        return;
      }
      ///////////
      const sqlQuery4 = {
        sql: "select count(1) as cnt from prd_workproc where cd_firm = :cd_firm and no_wo = :no_wo and no_line = :no_line",
        cd_firm: userInfo.cd_firm,
        no_wo: noWo,
        no_line: noLine,
      };
      const params4 = await getTablebySql(sqlQuery4);
      let cnt4 = params4?.length > 0 ? params4[0]["cnt"] : 0;

      if (cnt4 > 0) {
        showDialog("alter", "실적 정보가 존재 합니다.");
        return;
      }
      ///////////
      const sqlQuery5 = {
        sql: "select count(1) as cnt from prd_workproc where cd_firm = :cd_firm and no_wo = :no_wo and no_line = :no_line",
        cd_firm: userInfo.cd_firm,
        no_wo: noWo,
        no_line: noLine,
      };
      const params5 = await getTablebySql(sqlQuery5);
      let cnt5 = params5?.length > 0 ? params5[0]["cnt"] : 0;

      if (cnt5 > 0) {
        showDialog("alter", "이전 공정의 실적 정보가 존재 합니다.");
        return;
      }
      //DoRowUp
      //Swap no_line value and sort
      moveRow("up");
      // for (const node of gridApiRef3.current.api.getRenderedNodes()) {
      //   if (node.rowIndex === rowIndex) {
      //     gridApiRef3.current.setValue(node, "no_line", noLine2);
      //   } else if (node.rowIndex === rowIndex - 1) {
      //     gridApiRef3.current.setValue(node, "no_line", noLine);
      //   }
      // }

      // setTimeout(() => {
      //   gridApiRef3.current.api.refreshClientSideRowModel("sort");
      //   gridApiRef3.current.api.deselectAll();
      //   const newNode = gridApiRef3.current.api.getDisplayedRowAtIndex(
      //     rowIndex - 1
      //   );
      //   if (newNode) {
      //     newNode.setSelected(true);
      //     gridApiRef3.current.api.setFocusedCell(
      //       rowIndex - 1,
      //       focusedCellH.column
      //     );
      //   }
      // });
      // const ynend = "Y";
      // await new Promise((resolve) => setTimeout(resolve, 100));

      // const lastRow = gridApiRef3.current.api.getDisplayedRowAtIndex(
      //   gridApiRef3.current?.api.getDisplayedRowCount() - 1
      // );

      // for (const node of getRenderedNodes) {
      //   if (node.id === lastRow.id) continue;
      //   isYnEnd.current = false;
      //   gridApiRef3.current.setValue(node, "yn_end", !ynend);
      // }
      // gridApiRef3.current.setValue(lastRow, "yn_end", "Y");
    }
    //#region BtnDown
    if (id === "btnDown") {
      if (
        gridRefs.current["grid2"].current.getDisplayedRowCount() === 0 ||
        gridRefs.current["grid2"].current.getDisplayedRowCount() === 1
      ) {
        return;
      }
      const parendNodes = gridRefs.current["grid1"].current.focusedRowNode();
      const focusedRowNode = gridRefs.current["grid2"].current.focusedRowNode();
      if (
        focusedRowNode.length >=
        gridRefs.current["grid2"].current.getDisplayedRowCount() - 1
      )
        return;
      const noWo = focusedRowNode.data?.no_wo;
      const noLine = focusedRowNode.data?.no_line;

      // const sqlQuery1 = {
      //   sql: "select count(1) as cnt from prd_wo where cd_firm = #{cd_firm} and no_wo = #{no_wo} and (qt_rcv > 0)",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: noWo,
      // };
      // const params1 = await getTablebySql(sqlQuery1);
      // let cnt1 = params1?.length > 0 ? params1[0]["cnt"] : 0;

      if ((parendNodes.data.qt_rcv ?? 0) > 0) {
        showDialog("alter", "이미 진행된 건 입니다.");
        return;
      }
      //////////
      // const sqlQuery2 = {
      //   sql: "select count(1) as cnt from prd_woproc where cd_firm = #{cd_firm} and no_wo = #{no_wo} and no_line = #{no_line} and qt_work <> 0",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: noWo,
      //   no_line: noLine,
      // };
      // const params2 = await getTablebySql(sqlQuery2);
      // let cnt2 = params2?.length > 0 ? params2[0]["cnt"] : 0;

      //Focus node's qt_work
      if ((focusedRowNode.data?.qt_work ?? 0) !== 0) {
        showDialog("alter", "이미 진행된 건 입니다.");
        return;
      }
      ///////////
      // const sqlQuery3 = {
      //   sql: "select count(1) as cnt from prd_woproc where cd_firm = #{cd_firm} and no_wo = #{no_wo} and no_line = #{no_line} and qt_work <> 0",
      //   cd_firm: userInfo.cd_firm,
      //   no_wo: noWo,
      //   no_line: noLine2,
      // };
      // const params3 = await getTablebySql(sqlQuery3);
      // let cnt3 = params3?.length > 0 ? params3[0]["cnt"] : 0;

      //Next node's qt_work
      if ((focusedRowNode.data?.qt_work ?? 0) !== 0) {
        showDialog("alter", "이후 공정이 진행된 건 입니다.");
        return;
      }
      ///////////
      const sqlQuery4 = {
        sql: "select count(1) as cnt from prd_workproc where cd_firm = :cd_firm and no_wo = :no_wo and no_line = :no_line",
        cd_firm: userInfo.cd_firm,
        no_wo: noWo,
        no_line: noLine,
      };
      const params4 = await getTablebySql(sqlQuery4);
      let cnt4 = params4?.length > 0 ? params4[0]["cnt"] : 0;

      if (cnt4 > 0) {
        showDialog("alter", "실적 정보가 존재 합니다.");
        return;
      }
      ///////////
      const sqlQuery5 = {
        sql: "select count(1) as cnt from prd_workproc where cd_firm = :cd_firm and no_wo = :no_wo and no_line = :no_line",
        cd_firm: userInfo.cd_firm,
        no_wo: noWo,
        no_line: noLine,
      };
      const params5 = await getTablebySql(sqlQuery5);
      let cnt5 = params5?.length > 0 ? params5[0]["cnt"] : 0;

      if (cnt5 > 0) {
        showDialog("alter", "이후 공정의 실적 정보가 존재 합니다.");
        return;
      }

      //DoRowDown
      //Swap no_line value and sort
      moveRow("down");
      // for (const node of getRenderedNodes) {
      //   if (node.rowIndex === rowIndex) {
      //     gridApiRef3.current.setValue(node, "no_line", noLine2);
      //   } else if (node.rowIndex === rowIndex + 1) {
      //     gridApiRef3.current.setValue(node, "no_line", noLine);
      //   }
      //   if (rowIndex >= gridApiRef3.current?.api.getDisplayedRowCount() - 1) {
      //     gridApiRef3.current.setValue(node, "yn_end", "Y");
      //   }
      // }

      // setTimeout(() => {
      //   gridApiRef3.current.api.refreshClientSideRowModel("sort");
      //   gridApiRef3.current.api.deselectAll();
      //   const newNode = gridApiRef3.current.api.getDisplayedRowAtIndex(
      //     rowIndex + 1
      //   );
      //   if (newNode) {
      //     newNode.setSelected(true);
      //     gridApiRef3.current.api.setFocusedCell(
      //       rowIndex + 1,
      //       focusedCellH.column
      //     );
      //   }
      // });

      // const ynend = "Y";
      // await new Promise((resolve) => setTimeout(resolve, 100));

      // const focusedRow = gridApiRef3.current?.api.getDisplayedRowAtIndex(
      //   gridApiRef3.current.api.getFocusedCell().rowIndex
      // );
      // const lastRow = gridApiRef3.current.api.getDisplayedRowAtIndex(
      //   gridApiRef3.current?.api.getDisplayedRowCount() - 1
      // );

      // if (focusedRow.rowIndex === lastRow.rowIndex) {
      //   for (const node of getRenderedNodes) {
      //     isYnEnd.current = false;
      //     gridApiRef3.current.setValue(node, "yn_end", !ynend);
      //   }
      //   gridApiRef3.current.setValue(focusedRow, "yn_end", "Y");
      // }
    }
  };

  const moveRow = (direction: "up" | "down") => {
    const grid = gridRefs.current["grid3"].current;
    if (!grid) return;

    const selectedRows = grid.getSelectedRows();
    if (!selectedRows || selectedRows.length === 0) return;

    const selectedData = selectedRows[0];

    const nodes: any[] = [];
    let currentIndex = -1;

    grid.forEachNode((node: any) => {
      nodes.push(node);
      if (node.data === selectedData) {
        currentIndex = nodes.length - 1;
      }
    });

    if (currentIndex === -1) return;

    const targetIndex =
      direction === "up" ? currentIndex - 1 : currentIndex + 1;

    if (targetIndex < 0 || targetIndex >= nodes.length) return;

    const currentNode = nodes[currentIndex];
    const targetNode = nodes[targetIndex];

    const temp = { ...currentNode.data };

    currentNode.setDataValue("cd_op", targetNode.data.cd_op);
    targetNode.setDataValue("cd_op", temp.cd_op);

    currentNode.setDataValue("no_line", targetNode.data.no_line);
    targetNode.setDataValue("no_line", temp.no_line);
  };

  // const onRowClicked3 = (event: any) => {
  //   isYnEnd.current = true;
  // };
  const onSelectionChanged = (event: any) => {
    isYnEnd.current = true;
  };
  const TabChangedEvent = async (index: any) => {
    selectedTabPage.current = index;
  };
  const onRowClicked = (event: any) => {
    _nm_rout_old.current = event.data?.cd_rout;
    _cd_item_old.current = event.data?.cd_item;
  };
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;

    if (selectedRow) {
      const no_wo = selectedRow.no_wo;
      setSelectedDocu(no_wo);
      gridRefs.current["grid2"].current.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
      gridRefs.current["grid3"].current.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid3"].current.selectAndFocusRow(0);
      _nm_rout_old.current = selectedRow.cd_rout;
      _cd_item_old.current = selectedRow.cd_item;
    } else {
      return;
    }
  };
  //#region CellChanged1
  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;
    if (isDrilldownActive) return;
    let dt: any, dt2: any;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "cd_item") {
      let cdWh = "",
        nmWh,
        cdWhRcv,
        nmWhRcv,
        txtItemSpec,
        txtRmk;
      if (
        rowData.cd_item.toString().length > 0 &&
        rowData.cd_item !== _cd_item_old.current
      ) {
        const param = {
          cd_firm: userInfo.cd_firm,
          cd_biz: userInfo.cd_biz,
          cd_item: rowData.cd_item,
          tp_rout: rowData.tp_rout,
        };
        const params = {
          id: "sn_prd_wmo_reg_001_searchroutitem",
          params: param,
        };
        dt = await fnGetDataSet(params);
        if (dt[0].length === 0) return;

        if (dt[0][0].cd_rout.toString().length > 0) {
          rowNode.setDataValue("cd_rout", dt[0][0].cd_rout, "noEvent");
          rowNode.setDataValue("nm_rout", dt[0][0]?.nm_rout ?? "", "noEvent");
          rowNode.setDataValue("cd_wh", dt[0][0]?.cd_wh, "noEvent");
          rowNode.setDataValue("nm_wh", dt[0][0]?.nm_wh, "noEvent");
        }
        cdWh = dt[0][0].cd_wh;
        nmWh = dt[0][0].nm_wh;
        cdWhRcv = dt[0][0].cd_wh_rcv;
        nmWhRcv = dt[0][0].nm_wh_rcv;
        if (dt[0][0].cd_wh === "") {
          const sqlQuery1 = {
            sql: "select count(1) as cnt from mas_wh where cd_firm = :cd_firm and cd_biz = :cd_biz and yn_bf = 'Y' and yn_use 'Y'",
            cd_firm: userInfo.cd_firm,
            cd_biz: userInfo.cd_biz,
          };
          dt2 = await getTablebySql(sqlQuery1);

          if (dt2 !== undefined && dt2.length > 0) {
            let cnt1 = dt2?.length > 0 ? dt2[0]["cnt"] : 0;
            if (cnt1 === 1) {
              const sqlQuery2 = {
                sql: "select count(1) as cnt from mas_wh where cd_firm = :cd_firm and cd_biz = :cd_biz and yn_bf = 'Y' and yn_use 'Y'",
                cd_firm: userInfo.cd_firm,
                cd_biz: userInfo.cd_biz,
              };
              dt2 = await getTablebySql(sqlQuery2);
              if (dt2.length > 0) {
                cdWh = dt2[0].cd_wh;
                nmWh = dt2[0].nm_wh;
              }
            }
          }
        }
        if (cdWh === "") {
          const sqlQuery3 = {
            sql: "select mi.cd_wh_isu as cd_wh, mw.nm_wh from mas_item mi left outer join mas_wh mw on mw.cd_firm = mi.cd_firm and mw.cd_wh = mi.cd_wh_isu where mi.cd_firm = :cd_firm and mi.cd_item = :cd_item",
            cd_firm: userInfo.cd_firm,
            cd_item: rowData.cd_item,
          };
          dt2 = await getTablebySql(sqlQuery3);
          if (dt2.length > 0) {
            cdWh = dt2[0].cd_wh;
            nmWh = dt2[0].nm_wh;
          }
        }
        if (dt[0][0].cd_wo !== "" && dt[0][0].cd_wo !== null) {
          rowData.cd_wo = dt[0][0].cd_wo;
        }
        rowData.cd_wh_isu = cdWh;
        rowData.nm_wh_isu = nmWh;
        const sqlQuery4 = {
          sql: "select no_rev from prd_bomh where cd_firm = :cd_firm and cd_biz = :cd_biz and cd_item = :cd_item",
          cd_firm: userInfo.cd_firm,
          cd_biz: userInfo.cd_biz,
          cd_item: rowData.cd_item,
        };
        dt2 = await getTablebySql(sqlQuery4);
        if (dt2 && dt2.length > 0) {
          if (dt2[0]?.no_rev ?? "".toString().length > 0) {
            rowData.no_rev = dt[0].no_rev;
          }
        }
        if (dt[0][0].cd_wh_rcv !== "" && dt[0][0].cd_wh_rcv !== null) {
          const sqlQuery5 = {
            sql: "select coalesce(mi.cd_wh_rcv,'') as cd_wh_rcv, coalesce(mw.nm_wh,'') as nm_wh_rcv, coalesce(mi.txt_item_spec,'') as txt_item_spec, coalesce(mi.txt_rmk,'') as txt_rmk from mas_item mi left outer join mas_wh mw on mw.cd_firm = mi.cd_firm and mw.cd_wh = mi.cd_wh_rcv where mi.cd_firm = :cd_firm and mi.cd_item = :cd_item",
            cd_firm: userInfo.cd_firm,
            cd_item: rowData.cd_item,
          };
          dt2 = await getTablebySql(sqlQuery5);
          if (dt2.length > 0) {
            txtItemSpec = dt2[0].txt_item_spec;
            txtRmk = dt2[0].txt_rmk;
          }
        } else {
          const sqlQuery5 = {
            sql: "select  coalesce(mi.txt_item_spec,'') as txt_item_spec, coalesce(mi.txt_rmk,'') as txt_rmk from mas_item mi left outer join mas_wh mw on mw.cd_firm = mi.cd_firm and mw.cd_wh = mi.cd_wh_rcv where mi.cd_firm = :cd_firm and mi.cd_item = :cd_item",
            cd_firm: userInfo.cd_firm,
            cd_item: rowData.cd_item,
          };
          dt2 = await getTablebySql(sqlQuery5);
          if (dt2.length > 0) {
            txtItemSpec = dt2[0].txt_item_spec;
            txtRmk = dt2[0].txt_rmk;
          }
        }
        rowNode.setDataValue("cd_wh_rcv", cdWhRcv, "noEvent");
        rowNode.setDataValue("nm_wh_rcv", nmWhRcv, "noEvent");

        // updatedRow.txt_item_spec = txtItemSpec;
        // updatedRow.txt_rmk = txtRmk;

        if (_qtdy04_visible === true) {
          const sqlQuery5 = {
            sql: "select qt_dummy04 from mas_item where cd_firm = :cd_firm and cd_item = :cd_item",
            cd_firm: userInfo.cd_firm,
            cd_item: rowData.cd_item,
          };
          dt2 = await getTablebySql(sqlQuery5);
          if (dt2.length > 0) {
            rowData.qt_dummy04_mi = Number(dt2[0].qt_dummy04);
          }
        }
        gridRefs.current["grid1"].current.setFocusedCell(
          event.rowIndex,
          "qt_wo"
        );
        reload(rowNode);
        const sqlQuery1 = {
          sql: "select coalesce(r.cd_wo,'') as cd_wo, coalesce(r.cd_wh_good,'') as cd_wh_good, coalesce(wh.nm_wh,'') as nm_wh from prd_rout r left outer join mas_wh wh on r.cd_firm = wh.cd_firm and r.cd_wh_good = wh.cd_wh where r.cd_firm = :cd_firm and r.cd_rout = :cd_rout",
          cd_firm: userInfo.cd_firm,
          cd_rout: rowData.cd_rout,
        };
        dt = await getTablebySql(sqlQuery1);
        if (dt != null && dt.length > 0) {
          rowNode.setDataValue("cd_wo", dt[0].cd_wo);
          rowNode.setDataValue("cd_wh", dt[0].cd_wh_good, "noEvent");
        }
      } else rowNode.setDataValue("cd_rout", "", "noEvent");

      _cd_item_old.current = rowData.cd_item;
    }
    if (colId === "cd_rout") {
      if (_nm_rout_old.current !== rowData.cd_rout) {
        const sqlQuery1 = {
          sql: "select coalesce(r.cd_wo,'') as cd_wo, coalesce(r.cd_wh_good,'') as cd_wh_good, coalesce(wh.nm_wh,'') as nm_wh from prd_rout r left outer join mas_wh wh on r.cd_firm = wh.cd_firm and r.cd_wh_good = wh.cd_wh where r.cd_firm = :cd_firm and r.cd_rout = :cd_rout",
          cd_firm: userInfo.cd_firm,
          cd_rout: rowData.cd_rout,
        };
        dt = await getTablebySql(sqlQuery1);
        if (dt != null && dt.length > 0) {
          rowNode.setDataValue("cd_wo", dt[0].cd_wo, "noEvent");
          rowNode.setDataValue("cd_wh", dt[0].cd_wh_good, "noEvent");
          rowNode.setDataValue("nm_wh", dt[0].nm_wh, "noEvent");
        }
      }
      _nm_rout_old.current = rowData.cd_rout;
    }
    if (colId === "qt_wo") {
      // 한글 주석: 지시량 수정은 작업 진행 중에도 허용하되,
      // 실적수량(qt_work)보다 낮게 내리는 경우에만 막고 이전 값으로 되돌린다.
      const qtWorkDone = Number(rowData?.qt_work ?? 0);
      if (Number(event.newValue) < qtWorkDone) {
        await showDialog(
          "alter",
          `실적수량(${qtWorkDone})보다 적은 지시량으로 수정할 수 없습니다.`
        );
        rowNode.setDataValue("qt_wo", event.oldValue, "noEvent");
        return;
      }
      // 한글 주석: 필터된 행이 아니라 "편집된 행의 지시번호"로 대상을 찾는다.
      // 편집 중 다른 작업지시를 클릭하면 포커스 이벤트(필터 전환)가 값 변경 이벤트보다
      // 먼저 와서, 클릭된 지시의 하단 공정/자재에 이 행의 지시량이 기록되던 문제 방지.
      const targetNoWo = rowData?.no_wo ?? "";
      gridRefs.current["grid3"].current?.forEachNode((node: any) => {
        if ((node.data?.no_wo ?? "") !== targetNoWo) return;
        const unit = Number(node.data.qt_unit ?? 0);
        node.setDataValue("qt_need", unit * rowData.qt_wo, "noEvent");
      });

      gridRefs.current["grid2"].current?.forEachNode((node: any) => {
        if ((node.data?.no_wo ?? "") !== targetNoWo) return;
        node.setDataValue("qt_wo", rowData.qt_wo, "noEvent");
      });
    }

    if (colId === "cd_emp") {
      const sqlQuery2 = {
        sql: "select coalesce(cd_dept,'')as cd_dept from mas_emp where cd_firm = :cd_firm and cd_emp = :cd_emp",
        cd_firm: userInfo.cd_firm,
        cd_emp: rowData.cd_emp,
      };
      const params2 = await getTablebySql(sqlQuery2);
      if (params2 !== undefined && params2.length > 0) {
        rowData.cd_dept = params2[0].cd_dept;
      }
    }

    if (colId === "cd_wo") {
      if (rowData.cd_wo.toString().length > 0) {
        const sqlQuery2 = {
          sql: "select w.cd_cust_prd, mc.nm_cust as nm_cust_prd, w.yn_autorel, w.yn_autorcv, w.yn_autoreq, w.cd_io_isu, w.cd_io_rcv from mas_wotype w left outer join  mas_cust mc on w.cd_firm = mc.cd_firm and w.cd_cust_prd = mc.cd_cust where w.cd_firm = :cd_firm and w.cd_wo = :cd_wo",
          cd_firm: userInfo.cd_firm,
          cd_wo: rowData.cd_wo,
        };
        const params3 = await getTablebySql(sqlQuery2);
        if (params3 !== undefined && params3.length > 0) {
          if (params3[0].yn_autorel === "Y") {
            rowNode.setDataValue("st_wo", "R", "noEvent");
          } else {
            rowNode.setDataValue("st_wo", "F", "noEvent");
          }
          rowData.cd_cust_prd = params3[0].cd_cust_prd ?? "";
          rowData.nm_cust_prd = params3[0].nm_cust_prd ?? "";
          if (params3[0].yn_autorel.toString().length > 0) {
            rowNode.setDataValue(
              "yn_autorel",
              params3[0].yn_autorel,
              "noEvent"
            );
          }

          if (
            params3[0].cd_io_isu.toString().length > 0 &&
            params3[0].cd_io_rcv.toString().length > 0
          ) {
            rowNode.setDataValue(
              "yn_autorcv",
              params3[0].yn_autorcv,
              "noEvent"
            );
          }

          if (params3[0].yn_autoreq.toString().length > 0) {
            rowNode.setDataValue(
              "yn_autoreq",
              params3[0].yn_autoreq,
              "noEvent"
            );
          }
        }
      }
    }

    if (colId === "dt_wo") {
      rowData.dt_start = rowData.dt_wo;
      if (parseInt(rowData.dt_wo, 10) > parseInt(rowData.dt_end, 10)) {
        rowNode.setDataValue("dt_end", rowData.dt_wo, "noEvent");
      }
    }
    if (colId === "dt_start") {
      if (rowData.dt_end === "") {
        rowNode.setDataValue("dt_end", rowData.dt_start, "noEvent");
      } else if (
        parseInt(rowData.dt_start, 10) > parseInt(rowData.dt_end, 10)
      ) {
        showDialog("alter", "시작일이 종료일보다 이후입니다.");
        rowNode.setDataValue("dt_start", rowData.dt_end, "noEvent");
      }
    }
    if (colId === "dt_end") {
      if (rowData.dt_start === "") {
        rowNode.setDataValue("dt_start", rowData.dt_end, "noEvent");
      } else if (
        parseInt(rowData.dt_end, 10) < parseInt(rowData.dt_start, 10)
      ) {
        showDialog("alter", "종료일이 시작일보다 이전입니다.");
        rowNode.setDataValue("dt_end", rowData.dt_start, "noEvent");
      }
    }
  };

  //#region CellChanged2
  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    if (isDrilldownActive) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "qt_unit") {
      rowData.qt_need =
        rowData.qt_unit *
        gridRefs.current["grid1"].current.focusedRowNode().data?.qt_wo;
    }

    if (colId === "cd_matl") {
      if (
        rowData.cd_matl === "" ||
        rowData.cd_matl === null ||
        rowData.cd_matl === undefined
      )
        return;
      const sqlQuery2 = {
        sql: "select coalesce(mi.cd_wh_isu,'')as cd_wh_isu, coalesce(mw.nm_wh,'') as nm_wh_isu from mas_item mi left outer join mas_wh mw on mi.cd_firm = mw.cd_firm and mi.cd_wh_isu = mw.cd_wh where mi.cd_firm = :cd_firm and mi.cd_item = :cd_item",
        cd_firm: userInfo.cd_firm,
        cd_item: rowData.cd_matl,
      };
      const params2 = await getTablebySql(sqlQuery2);
      let cdWhIsu = params2[0]?.cd_wh_isu ?? "";
      let nmWhIsu = params2[0]?.nm_wh_isu ?? "";
      rowData.cd_wh = cdWhIsu;
      rowData.nm_wh = nmWhIsu;
    }
    if (colId === "cd_wh") {
      const rowCount = gridRefs.current["grid3"].current.getDisplayedRowCount();
      if (rowCount === 1) return;
      if (!rowData.cd_wh) return;

      let apply = false;
      gridRefs.current["grid3"].current.forEachFilteredNode((node: RowNode) => {
        if (
          node.data[colId] === "" ||
          node.data[colId] === null ||
          node.data[colId] === undefined
        )
          apply = true;
      });
      if (!apply) return;

      const confirm = await showDialog(
        "confirm",
        "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
      );

      if (confirm) {
        gridRefs.current["grid3"].current.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data.cd_wh === "" ||
              node.data.cd_wh === null ||
              node.data.cd_wh === undefined
            ) {
              node.setDataValue("cd_wh", rowData.cd_wh);
              node.setDataValue("nm_wh", rowData.nm_wh);
            }
          }
        );
      }
    }
  };

  //#region CellChanged3
  const onCellValueChanged3 = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    if (colId !== "yn_end") return;
    if (!isYnEnd.current) return;

    // Y로 바뀐 경우 → 다른 행은 전부 N
    if (rowData.yn_end === "Y") {
      gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
        if (!node?.data) return;
        if (node.data.KeyField === rowData.KeyField) return;

        node.setDataValue("yn_end", "N", "noEvent");
      });
    }
    // N으로 바꾸려는 시도 → 다시 Y로 고정
    else if (rowData.yn_end === "N") {
      rowNode.setDataValue("yn_end", "Y", "noEvent");
    }

    isYnEnd.current = false;
  };

  //#region onActivate
  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const selectedData = {
        cd_firm: nodeData.cd_firm,
        cd_biz: nodeData.cd_biz,
        dt_from: nodeData.dt_woreq,
        dt_to: nodeData.dt_woreq,
      };
      setFormData(selectedData);
      onSearch();
    } else if ((Menuprops.figure as string) === "fg_drilldown.Registration") {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      const modifiedRowsL = gridRefs.current["grid3"].current.getChange();
      if (
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0
      ) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm === true) {
          await onSave();
          await setDrilldown();
          return;
        } else if (confirm === false) {
          gridRefs.current["grid1"].current.resetUpdate();
          gridRefs.current["grid3"].current.resetUpdate();
          await setDrilldown();
          return;
        } else {
          return;
        }
      } else {
        await setDrilldown();
      }
    }
  };
  const [isDrilldownActive, setIsDrilldownActive] = useState(false);

  const setDrilldown = async () => {
    setIsDrilldownActive(true);
    const drill = {
      cd_firm: userInfo?.cd_firm,
      no_so: Menuprops.nodeData[0],
      no_line: Menuprops.nodeData[1],
    };

    const param = {
      id: "sn_prd_wmo_reg_001_searchrefso",
      params: drill,
    };
    const data = await fnGetDataSet(param);
    const focusedRow = gridRefs.current["grid1"].current?.focusedRowNode();
    const headerResult = data[0];

    if (headerResult) {
      await onInsert();
      for (const key in headerResult[0]) {
        if (headerResult[0][key]) {
          focusedRow.setDataValue(key, headerResult[0][key], "noEvent");
        }
      }
    }
    setIsDrilldownActive(false);
  };

  //#region OnPopMenu
  const handleContextMenu = async (params: any) => {
    const grid = gridRefs.current["grid1"].current;

    if (params.id === "wf_sn_prd_wo_info") {
      const rowNode = gridRefs.current["grid1"].current.focusedRowNode();

      if (!rowNode) {
        await showDialog("alter", "선택된 행이 없습니다.");
        return;
      }
      if (!Menuprops.cd_menu) {
        await showDialog("alter", "메뉴 코드가 없습니다.");
        return;
      }
      // id_target은 호출 메뉴에서 전달 (고정값 아님)
      const idTarget = "grid1";

      const result = await openAddInfoRegPopup({
        title: "지시부가항목",
        cd_menu: Menuprops.cd_menu,
        id_target: idTarget,
        rowData: { ...rowNode.data },
        width: "980px",
        height: "760px",
        rememberSizeKey: "SN_PRD_WMO_REG_001",
      });
      if (!result || result === "close") return;

      const values = result?.values ?? {};
      Object.keys(values).forEach((key) => {
        rowNode.setDataValue(key, values[key]);
      });
    }
    switch (params) {
      /* =====================================================
       * Drill Down
       * ===================================================== */

      case "fn_sn_prd_com_wmo_reg_04": {
        let selectedRow: any = null;

        grid.forEachFilteredNode((node: any) => {
          if (node.isSelected && node.isSelected()) {
            selectedRow = node.data;
          }
        });

        if (!selectedRow) return;

        const returnData = [selectedRow.no_wo, selectedRow.dt_wo];

        const drillDown = menuItems?.find(
          (item: any) => item?.cd_menu === "SN_PRD_WMO_REG_002"
        );

        if (!drillDown) return;

        const filePath =
          `./${drillDown.cd_module}/${drillDown.cd_menu}/${drillDown.cd_menu}`.toUpperCase();

        (window as any).onActivate(
          drillDown.cd_menu,
          drillDown.nm_menu,
          drillDown.cd_module,
          filePath,
          drillDown,
          drillDown.nm_path,
          returnData,
          "fg_drilldown.Search"
        );
        break;
      }

      /* =====================================================
       * 마감처리
       * ===================================================== */
      case "wf_sn_confirm": {
        let hasSelected = false;

        grid.forEachFilteredNode((node: any) => {
          if (!node.isSelected || !node.isSelected()) return;
          hasSelected = true;

          if (node.data?.st_wo === "C") {
            showDialog("error", "처리 실패. 미마감인건이 없습니다.");
            return;
          }

          node.setDataValue("st_wo", "C", "noEvent");
        });

        if (hasSelected) {
          await onSave();
        }
        break;
      }

      /* =====================================================
       * 마감취소
       * ===================================================== */
      case "wf_sn_confirm_cancel": {
        let hasSelected = false;

        grid.forEachFilteredNode(async (node: any) => {
          if (!node.isSelected || !node.isSelected()) return;
          hasSelected = true;

          const row = node.data;

          if (row?.qt_work !== 0) {
            if (row?.st_wo === "S") {
              showDialog("error", "처리 실패. 마감인건이 없습니다.");
              return;
            }

            if (row?.qt_rcv > 0) {
              const confirm = await showDialog(
                "confirm",
                `작업지시(${row.no_wo})는 입고수량이 등록되어 있습니다.\n마감취소 하시겠습니까?`
              );
              if (!confirm) return;
            }

            node.setDataValue("st_wo", "S", "noEvent");
          } else if (row?.qt_work === 0 && row?.yn_autorel === "N") {
            if (row?.st_wo === "R") {
              showDialog("error", "처리 실패. 마감인건이 없습니다.");
              return;
            }

            if (row?.qt_rcv > 0) {
              const confirm = await showDialog(
                "confirm",
                `작업지시(${row.no_wo})는 입고수량이 등록되어 있습니다.\n마감취소 하시겠습니까?`
              );
              if (!confirm) return;
            }

            node.setDataValue("st_wo", "R", "noEvent");
          } else {
            showDialog("error", "처리 실패. 마감인건이 없습니다.");
            return;
          }
        });

        if (hasSelected) {
          await onSave();
        }
        break;
      }
    }
  };
  const reload = async (selectedNode: any) => {
    //if (selectedNode.data?.qt_wo === 0) {
    //  showDialog("alter", "지시량정보가 누락 되었습니다.");
    //  return;
    // }
    if (!selectedNode.data?.cd_rout) {
      showDialog("alter", "라인정보가 누락 되었습니다.");
      return;
    }
    const sqlQuery2 = {
      sql: "select st_wo, coalesce(qt_work,0) as qt_work from prd_wo where cd_firm = :cd_firm and no_wo = :no_wo",
      cd_firm: userInfo.cd_firm,
      no_wo: selectedNode.data?.no_wo,
    };
    const params2 = await getTablebySql(sqlQuery2);
    if (params2?.length > 0) {
      // 한글 주석: 자동발행(yn_autorel=Y) 지시는 발행(R) 상태여도 확정과 동일하게 재전개를 허용한다.
      if (
        params2[0]["st_wo"] === "C" ||
        (params2[0]["st_wo"] === "R" && selectedNode.data?.yn_autorel !== "Y")
      ) {
        showDialog(
          "alter",
          "지시상태가 마감 또는 발행인 경우 재전개 하실 수 없습니다."
        );
        return;
      } else if (params2[0]["qt_work"] > 0) {
        showDialog("alter", "실적등록된 경우 재전개 하실 수 없습니다.");
        return;
      }
    }
    if (selectedNode.data?.no_wo !== "") {
      const sqlQuery = {
        sql: "select count(*) as cnt from mtl_isureql where cd_firm = :cd_firm and no_order = :no_order",
        cd_firm: userInfo.cd_firm,
        no_order: selectedNode.data?.no_wo,
      };
      const params = await getTablebySql(sqlQuery);
      let cnt = params?.length > 0 ? params[0]["cnt"] : 0;
      if (cnt > 0) {
        showDialog("alter", "청구등록된 경우 재전개 하실 수 없습니다.");
        return;
      }
    }

    if (!gridRefs.current["grid1"].current.requiredValuesCheck()) {
      return;
    }
    gridRefs.current["grid2"].current?.deleteAllRows();
    const param = {
      cd_firm: userInfo.cd_firm,
      cd_rout: selectedNode.data?.cd_rout,
    };
    noLineP.current = 0;
    const searchParam = {
      id: "sn_prd_wmo_reg_001_searchrout",
      params: param,
    };
    _dt.current = await fnGetDataSet(searchParam);

    // 한글 주석: st_proc의 원본인 st_wo를 addRow 루프 전에 확정한다.
    // cd_rout 입력 경로에서 reload(await 없음)와 cd_wo 핸들러(mas_wotype 조회 후 st_wo 세팅)가
    // 서로 다른 HTTP 응답 순서로 경합해, 공정행 생성 시점의 st_wo가 옛 값/빈 값일 수 있다.
    // 기존 지시는 DB의 st_wo, 신규행은 라우팅의 작업지시유형(yn_autorel)으로 R/F를 직접 판정한다.
    let stWo = params2?.length > 0 ? params2[0]["st_wo"] : "";
    if (!stWo) {
      const wtQuery = {
        sql: "select case when coalesce(w.yn_autorel,'N') = 'Y' then 'R' else 'F' end as st_wo from prd_rout r inner join mas_wotype w on w.cd_firm = r.cd_firm and w.cd_wo = r.cd_wo where r.cd_firm = :cd_firm and r.cd_rout = :cd_rout",
        cd_firm: userInfo.cd_firm,
        cd_rout: selectedNode.data?.cd_rout,
      };
      const wt = await getTablebySql(wtQuery);
      stWo = wt?.length > 0 ? wt[0]["st_wo"] : (selectedNode.data?.st_wo ?? "");
    }
    if (stWo && selectedNode.data?.st_wo !== stWo) {
      selectedNode.setDataValue("st_wo", stWo, "noEvent");
    }

    if (_dt.current.length > 0) {
      for (let i = 0; i < _dt.current[0].length; i++) {
        _chk_newRow.current = "R";
        const newRow = {};
        gridRefs.current["grid2"].current.addRow(newRow);
      }
    }
    // -----
    // 여기서부터 자재정보
    // -----
    if (!gridRefs.current["grid1"].current.requiredValuesCheck()) {
      return;
    }
    let ynPhn;
    let tpRout;
    gridRefs.current["grid3"].current?.deleteAllRows();
    const param2 = {
      cd_firm: userInfo.cd_firm,
      cd_biz: userInfo.cd_biz,
      cd_item: selectedNode.data?.cd_item,
      dt_start: selectedNode.data?.dt_start,
    };
    const params = {
      id: "sn_prd_wmo_reg_001_searchbom",
      params: param2,
    };
    const data: any = await fnGetDataSet(params);
    if (data[0] && data[0].length > 0) {
      if (selectedNode.data?.tp_rout === "") {
        const sqlQuery1 = {
          sql: "select tp_rout from prd_rout where cd_firm = :cd_firm and cd_biz = :cd_biz and cd_rout = :cd_rout",
          cd_firm: userInfo.cd_firm,
          cd_biz: userInfo.cd_biz,
          cd_rout: selectedNode.data?.cd_rout,
        };
        const params1 = await getTablebySql(sqlQuery1);
        if (params1?.length > 0) {
          tpRout = params1[0]["tp_rout"];
        }
      } else {
        tpRout = selectedNode.data?.tp_rout;
      }
      const conFirm = await showDialog(
        "confirm",
        "소요자재에 팬텀품목이 존재합니다. 팬텀 하위품목을 전개하시겠습니까?"
      );
      if (conFirm) {
        ynPhn = "Y";
      } else {
        ynPhn = "N";
      }
      const param = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        yn_phn: ynPhn,
        tp_rout: tpRout,
        cd_item: selectedNode.data?.cd_item,
        qt_wo: selectedNode.data?.qt_wo,
        dt_start: selectedNode.data?.dt_start,
      };
      const params = {
        id: "sn_prd_wmo_reg_001_searchphn",
        params: param,
      };
      _dt.current = await fnGetDataSet(params);
      if (_dt.current.length > 0) {
        noLineP.current =
          gridRefs.current["grid3"].current.getDisplayedRowCount();
        noLineP.current =
          gridRefs.current["grid3"].current.getDisplayedRowCount();
        for (let i = 0; i < _dt.current[0].length; i++) {
          _chk_newRow.current = "P";
          const newRow = {};
          gridRefs.current["grid3"].current?.addRow(newRow);
        }
      }
    }
    if (gridRefs.current["grid3"].current.getDisplayedRowCount() === 0) {
      const param = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_item: selectedNode.data?.cd_item,
        dt_start: selectedNode.data?.dt_start,
      };
      noLineP.current = 0;
      const params = {
        id: "sn_prd_wmo_reg_001_searchboml",
        params: param,
      };
      _dt.current = await fnGetDataSet(params);
      // 기존 데이터 보존

      // 새로운 데이터 가져오기

      // 두 객체를 합침 (newData가 existingData의 키를 덮어쓸 수 있음)
      const sqlQuery1 = {
        sql: "select coalesce(r.cd_wh_isu,'') as cd_wh_isu, coalesce(wh.nm_wh,'') as nm_wh from prd_rout r left outer join mas_wh wh on r.cd_firm = wh.cd_firm and r.cd_wh_isu = wh.cd_wh where r.cd_firm = :cd_firm and r.cd_rout = :cd_rout",
        cd_firm: userInfo.cd_firm,
        cd_rout: selectedNode.data.cd_rout,
      };
      const newData = await getTablebySql(sqlQuery1);
      tmp_cd_wh.current = newData;
      if (!_dt.current[0]) return;
      for (let i = 0; i < _dt.current[0].length; i++) {
        _chk_newRow.current = "B";
        const newRow = {};
        gridRefs.current["grid3"].current?.addRow(newRow);
      }
    }
  };
  const onGrid1ExtraHeaderMenuClick = async (event: {
    id: string;
    params: any;
  }) => {
    switch (event.id) {
      case "extra_item_setting":
        // 부가항목설정 실행
        await onOpenAddInfoPopup("grid1");
        break;
      default:
        break;
    }
  };
  const onOpenAddInfoPopup = async (idTarget = "grid1") => {
    // id_target에 해당하는 현재 컬럼 메타를 설정 팝업으로 전달한다.
    const columnInfos =
      idTarget === "grid2" ? columns.grid2 || [] : columns.grid1 || [];
    const saved = await openAddInfoPopup({
      cd_menu: Menuprops.cd_menu!,
      id_target: idTarget,
      columnInfos,
    });

    if (saved) {
      const rtn: any = await getInitFormData();
      setFormControlData(rtn.formControlData);
      setFormData((prev: any) => ({
        ...(rtn.formData || {}),
        ...(prev || {}),
      }));

      const popup_apply1 = [
        { target: "cd_cust_sales", source: "cd_cust" },
        { target: "nm_cust_sales", source: "nm_cust_sort" },
      ];
      const popup_apply2 = [
        { target: "cd_cust_pur", source: "cd_cust" },
        { target: "nm_cust_pur", source: "nm_cust_sort" },
      ];
      const grid1 = rtn.grid.grid1.map((col: any) => {
        let newCol = { ...col };
        if (col.cd_column === "cd_cust_sales") {
          newCol.popup_apply = popup_apply1;
        }
        return newCol;
      });
      const grid2 = rtn.grid.grid2.map((col: any) => {
        let newCol = { ...col };
        if (col.cd_column === "cd_cust_pur") {
          newCol.popup_apply = popup_apply2;
        }
        return newCol;
      });
      const configGrid1 = setConfigToColumns(grid1, "SAL0010");
      setColums({
        grid1: configGrid1,
        grid2: grid2,
        sheet1: rtn.grid.sheet1,
      });
      setHeaderInfo({
        grid1: rtn.header.grid1,
        grid2: rtn.header.grid2,
      });

      // 한글 주석: 항목설정 변경 후 저장 키 목록을 다시 로드한다.
      idTarget === "grid2"
        ? await loadAddInfoFlags(idTarget, setAddInfoFlags2)
        : await loadAddInfoFlags(idTarget, setAddInfoFlags);

      await onSearch();
    }
  };
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onRowClicked: onRowClicked,
          onCellValueChanged: onCellValueChanged,
          onBeforeAddRow: onBeforeAddRowH,
          onContextMenu: handleContextMenu,
          onExtraHeaderMenuClick: onGrid1ExtraHeaderMenuClick,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onSelectionChanged: onSelectionChanged,
          onContextMenu: handleContextMenu,
          onCellValueChanged: onCellValueChanged3,
          onBeforeAddRow: onBeforeAddRowL2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onContextMenu: handleContextMenu,
          onCellValueChanged: onCellValueChanged2,
          onBeforeAddRow: onBeforeAddRowL,
        },
      },
    }),
    [columns, dataSources]
  );
  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            // Pros로 받은 Menuprops
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              title: "작업지시",
              extraHeaderMenuItems: [
                {
                  id: "extra_item_setting",
                  name: "부가항목설정",
                  visible: true,
                },
              ],
            }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"반제품작업지시등록"}
                  onClick={() => {
                    onBtnsClick("btnHalfItem");
                  }}
                />
                <SnButton
                  text={"의뢰적용"}
                  onClick={() => {
                    onBtnsClick("btnAppReq");
                  }}
                />
                <SnButton
                  text={"작업사양"}
                  onClick={() => {
                    onBtnsClick("btnDetail");
                  }}
                />
              </div>
            }
          />
        </SnResizable>
        <div
          style={{
            display: "flex",
            width: "90%",
            alignItems: "center",
            gap: "10px",
            margin: "10px 0px 0px 0px",
          }}
        ></div>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnTab
            titles={["공정정보", "자재정보"]}
            width={"100%"}
            onTabChanged={TabChangedEvent}
            header={[
              <SnTabHeader
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"▲"}
                      onClick={() => {
                        onBtnsClick("btnUp");
                      }}
                    />
                    <SnButton
                      text={"▼"}
                      onClick={() => {
                        onBtnsClick("btnDown");
                      }}
                    />
                    <SnButton
                      text={"재전개"}
                      onClick={() => {
                        onBtnsClick("btnReload");
                      }}
                    />
                  </div>
                }
                onBtnAddClick={onBtnsClick}
                onBtnDeleteClick={onBtnsClick}
              />,
              <SnTabHeader
                body={
                  <div>
                    <SnButton
                      text={"재전개"}
                      onClick={() => {
                        onBtnsClick("btnReload");
                      }}
                    />
                  </div>
                }
                onBtnAddClick={onBtnsClick}
                onBtnDeleteClick={onBtnsClick}
              />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                events={grids.grid2.events}
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,

              <SnGrid
                ref={gridRefs.current["grid3"]} // Grid Name
                columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                rowData={grids.grid3.dataSource} // Datasource
                events={grids.grid3.events}
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,
            ]}
          />
        </SnResizable>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WMO_REG_001;
